<template>
	<Layout style="height: 100%" class="main">

		<Sider breakpoint="md" hide-trigger collapsible :width="256" :collapsed-width="64" v-model="collapsed"
			class="left-sider" :style="{overflow: 'hidden'}">
			<div class="logo-con">
				<img v-show="!collapsed" :src="maxLogo" key="max-logo" />
				<img v-show="collapsed" :src="minLogo" key="min-logo" />
			</div>
			<div id="">
				<div class="basinfo">
					<div class="touxiang">
						<div class="information">
							<p class="info kutop">
								<span class="infospan">姓&nbsp;&nbsp;&nbsp;名：</span>
								<span style="color:#63B3E6;cursor: pointer;font-size:18px"
									@click="goToMycenter">{{userInfo.name}}</span>
								<!--span id="kudos">
									<img :src="userInfo.userNotice.lastReadNotice.logo" style="width: 30px;"/>
								</span-->
							</p>
							<p class="info">
								<span class="infospan">座席号：</span>
								<span class="infoinfo">{{userInfo.phone}}</span>
							</p>
							<p class="info">
								<span class="infospan">客户经理工号：</span>
								<span class="infoinfo">{{userInfo.id+1000}}</span>
							</p>
							<p class="info" v-if="userInfo.set_open">
								<span class="infospan">数据开关：</span>
								<span class="infoinfo">
									<i-switch class="margin_flex" style="margin-bottom: 5px"
										v-model="userInfo.data_open" @on-change="dataOpen">
										<span slot="open">开</span>
										<span slot="close">关</span>
									</i-switch>
								</span>
							</p>
							<p class="info">
								<span class="infospan">城&nbsp;&nbsp;&nbsp;市：</span>
								<span class="infoinfo">{{userInfo.city}}</span>
							</p>
							<p class="info" v-if="userInfo.role_type != 3">
								<span class="infospan">所在部门：</span>
								<span class="infoinfo" style="padding:1px 0;">
									{{userInfo.departmentName}}
								</span>
							</p>
							<p class="info" v-if="userInfo.role_type != 3 && userInfo.role_type != 1">
								<Select v-model="departmentId" style="width:100px" @on-change="departmentMemberSelect"
									:transfer=true>
									<Option v-for="item in departmentList" :value="item.id" :key="item.id">
										{{ item.name }}
									</Option>
								</Select>
								<Select v-model="userId" style="width:100px" :transfer=true>
									<Option v-for="item in userList" :value="item.id" :key="item.id">
										{{ item.name }}
									</Option>
								</Select>
								<ButtonGroup>
									<Button @click="switchAccound">切换</Button>
									<Button @click="backAccound" type="primary">还原</Button>
								</ButtonGroup>
							</p>
							<p class="info" v-if="userInfo.role_type == 1 || userInfo.role_type == 3">
								<Select v-model="userId" style="width:100px" :transfer=true>
									<Option v-for="item in userInfo.departmentList" :value="item.id" :key="item.id">
										{{ item.name }}
									</Option>
								</Select>
								<ButtonGroup>
									<Button @click="switchAccound">切换</Button>
									<Button @click="backAccound" type="primary">还原</Button>
								</ButtonGroup>
							</p>
							<div style="clear:both;"></div>
							<p></p>
						</div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<Menu ref="menus" theme="light" :StaticEnableDefaultPopOutImage="false" @on-select='turnToPage'
				@on-open-change="openMenuItem" :active-name="$route.name" :open-names="openMenuName">
				<template v-for="item in userInfo.menuList">
					<div v-if="currentCenter == 'workCenter'">
						<MenuItem v-if="item.children.length<1 && item.show_depth == 1" :name="item.key"
							:key="'menuitem' + item.name" class="basinfo">
						<Icon :type="item.icon" :key="'menuicon' + item.name" size="20"></Icon>
						<span class="layout-text" style="font-weight: bold;"
							:key="'title' + item.name">{{ item.name }}</span>
						<div class="badge">
							<Badge v-if="item.key == 'redistribution_client'"
								:count="userInfo.userNotice.clientRedistribution" overflow-count="999"
								@click="redistributionNotFollow"></Badge>
						</div>
						<div class="badge">
							<Badge v-if="item.key == 'myclient'" :count="userInfo.userNotice.clientUndeal"
								overflow-count="999" @click="redistributionNotFollow"></Badge>
						</div>
						</MenuItem>
						<Submenu v-if="item.children.length >= 1 && item.show_depth == 1" :name="item.key"
							:key="item.name" class="basinfo">
							<template slot="title">
								<Icon :type="item.icon" size="20"></Icon>
								<span class="layout-text" style="font-weight: bold;">{{ item.name }}</span>
							</template>
							<template v-for="child in item.children">
								<MenuItem :name="child.key" :key="'menuitem' + child.name">
								<span class="layout-text" style="font-weight: bold;"
									:key="'title' + child.name">{{ child.name }}</span>
								</MenuItem>
							</template>
						</Submenu>
					</div>
					<div v-if="currentCenter == 'dataCenter'">
						<MenuItem v-if="item.children.length<1 && item.show_depth == 2" :name="item.key"
							:key="'menuitem' + item.name" class="basinfo">
						<Icon :type="item.icon" :key="'menuicon' + item.name" size="20"></Icon>
						<span class="layout-text" style="font-weight: bold;"
							:key="'title' + item.name">{{ item.name }}</span>
						<div class="badge">
							<Badge v-if="item.key == 'redistribution_client'"
								:count="userInfo.userNotice.clientRedistribution" overflow-count="999"
								@click="redistributionNotFollow"></Badge>
						</div>
						<div class="badge">
							<Badge v-if="item.key == 'myclient'" :count="userInfo.userNotice.clientUndeal"
								overflow-count="999" @click="redistributionNotFollow"></Badge>
						</div>
						</MenuItem>
						<Submenu v-if="item.children.length >= 1 && item.show_depth == 2" :name="item.key"
							:key="item.name" class="basinfo">
							<template slot="title">
								<Icon :type="item.icon" size="20"></Icon>
								<span class="layout-text" style="font-weight: bold;">{{ item.name }}</span>
							</template>
							<template v-for="child in item.children">
								<MenuItem :name="child.key" :key="'menuitem' + child.name">
								<span class="layout-text" style="font-weight: bold;"
									:key="'title' + child.name">{{ child.name }}</span>
								</MenuItem>
							</template>
						</Submenu>
					</div>
					<div v-if="currentCenter == 'systemSetting'">
						<MenuItem v-if="item.children.length<1 && item.show_depth == 3" :name="item.key"
							:key="'menuitem' + item.name" class="basinfo">
						<Icon :type="item.icon" :key="'menuicon' + item.name" size="20"></Icon>
						<span class="layout-text" style="font-weight: bold;"
							:key="'title' + item.name">{{ item.name }}</span>
						<div class="badge">
							<Badge v-if="item.key == 'redistribution_client'"
								:count="userInfo.userNotice.clientRedistribution" overflow-count="999"
								@click="redistributionNotFollow"></Badge>
						</div>
						<div class="badge">
							<Badge v-if="item.key == 'myclient'" :count="userInfo.userNotice.clientUndeal"
								overflow-count="999" @click="redistributionNotFollow"></Badge>
						</div>
						</MenuItem>
						<Submenu v-if="item.children.length >= 1 && item.show_depth == 3" :name="item.key"
							:key="item.name" class="basinfo">
							<template slot="title">
								<Icon :type="item.icon" size="20"></Icon>
								<span class="layout-text" style="font-weight: bold;">{{ item.name }}</span>
							</template>
							<template v-for="child in item.children">
								<MenuItem :name="child.key" :key="'menuitem' + child.name">
								<span class="layout-text" style="font-weight: bold;"
									:key="'title' + child.name">{{ child.name }}</span>
								</MenuItem>
							</template>
						</Submenu>
					</div>
					<div v-if="currentCenter == 'operationCenter'">
						<MenuItem v-if="item.children.length<1 && item.show_depth == 4" :name="item.key"
							:key="'menuitem' + item.name" class="basinfo">
						<Icon :type="item.icon" :key="'menuicon' + item.name" size="20"></Icon>
						<span class="layout-text" style="font-weight: bold;"
							:key="'title' + item.name">{{ item.name }}</span>
						<div class="badge">
							<Badge v-if="item.key == 'redistribution_client'"
								:count="userInfo.userNotice.clientRedistribution" overflow-count="999"
								@click="redistributionNotFollow"></Badge>
						</div>
						<div class="badge">
							<Badge v-if="item.key == 'myclient'" :count="userInfo.userNotice.clientUndeal"
								overflow-count="999" @click="redistributionNotFollow"></Badge>
						</div>
						</MenuItem>
						<Submenu v-if="item.children.length >= 1 && item.show_depth == 4" :name="item.key"
							:key="item.name" class="basinfo">
							<template slot="title">
								<Icon :type="item.icon" size="20"></Icon>
								<span class="layout-text" style="font-weight: bold;">{{ item.name }}</span>
							</template>
							<template v-for="child in item.children">
								<MenuItem :name="child.key" :key="'menuitem' + child.name">
								<span class="layout-text" style="font-weight: bold;"
									:key="'title' + child.name">{{ child.name }}</span>
								</MenuItem>
							</template>
						</Submenu>
					</div>
				</template>
			</Menu>
		</Sider>
		<Layout>
			<Row style="display: block;">
				<Col span="24">
				<Menu mode="horizontal" :active-name="currentCenter" @on-select='openMenuClass'>
					<MenuItem name="workCenter" >
					<Icon type="ios-paper" />
					工作中心
					</MenuItem>
					<MenuItem name="operationCenter"
						v-if="(userInfo.role_type == 1 || userInfo.role_type == 14 || userInfo.role_type == 15 || userInfo.role_type == 16) && userInfo.shop_id == 0">
					<Icon type="md-grid" />
					投放中心
					</MenuItem>
					<MenuItem name="dataCenter" v-if="userInfo.role_type != 14 && userInfo.role_type != 15 && userInfo.role_type != 16">
					<Icon type="md-podium" />
					数据中心
					</MenuItem>
					<MenuItem name="systemSetting" v-if="userInfo.role_type != 14 && userInfo.role_type != 15 && userInfo.role_type != 16">
					<Icon type="ios-settings" />
					系统设置
					</MenuItem>
					<span style="float: right;margin-right: 50px;">
						<user :message-unread-count="unreadCount" :user-avatar="userAvatar" :userInfo="userInfo" />
					</span>
				</Menu>
				</Col>
			</Row>
			<!--Header class="header-con">
				<header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">

				</header-bar>
			</Header-->
			<Content class="main-content-con">
				<Layout class="main-layout-con">
					<div class="tag-nav-wrapper">
						<tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag" />
					</div>
					<Content class="content-wrapper">
						<keep-alive :include="cacheList">
							<router-view v-if="$route.meta.keepAlive"></router-view>
						</keep-alive>
						<ABackTop :height="100" :bottom="130" :right="50" container=".content-wrapper"></ABackTop>
					</Content>
				</Layout>
			</Content>
			<div>
				<div class="message_tool" v-if="isOpenMsg == false" @click="closeMsg(true)">
					<div style="position: relative; height: 60px;"><img src="@/assets/images/message.png" class="icon">
						<div class="noread_num">{{msgCount}}</div>
					</div>
				</div>
				<div :class="isOpenMsg==true?'warning-msg':'warning-msg-close'">
					<div>
						<div class="message_div message_div_show">
							<div class="title">重要消息中心</div>
							<div class="content">
								<div class="one_div_l  one_div" v-for="(item, index) in msgList" :key="index">
									<div class="msg_title">
										{{item.type}}
										<span class="status" @click="signToRead(item)">【标记成已读】</span>
									</div>
									<div class="msg_content">{{item.notice_msg}}</div>
									<div class="opt">
										<div class="time">{{item.msg_time}}</div>
										<div class="go" @click='edit(item)' style="cursor: pointer;"
											v-if="item.notice_client_id != '' && item.notice_client_id != 0 && item.notice_client_id != null">
											去查看</div>
										<div style="clear: both;"></div>
									</div>
								</div>
							</div>
							<div style="text-align: center; padding-top: 8px;"><span
									style="font-size: 14px; line-height: 18px;cursor: pointer;"
									@click="signAllRead(msgList)">【全部标记已读】</span>
							</div>
							<img src="@/assets/images/close.png" class="shouce_guanbi" @click="closeMsg(false)">
							<span class="ge_to_log" style="cursor: pointer;" @click="openAllMsg">[所有消息]</span>
						</div>
					</div>
				</div>
			</div>
		</Layout>
		<Modal v-model="msgModal" width="900" title="所有消息通知">
			<MsgList @reloadData="myTips"></MsgList>
		</Modal>
		<!-- 客户提醒 -->
		<Modal v-model="clientTipsModal" :title="clientTips.title" cancel-text="">
			<p v-if="clientTips.type == 1">您与<span class='client_name' @click='editTipsModal(clientTips.id,clientTips.name)' :data-id='clientTips.id'
					:data-name='clientTips.name'
					style="display: inline-block;margin: 0 4px;color: #85c72f;cursor: pointer;">{{clientTips.name}}</span>客户{{clientTips.plat_at}}预约提醒已到期，请及时处理，提醒内容<br>提醒内容：{{clientTips.remark}}<br>
			<p v-if="clientTips.type == 1" style="color: #006600;">（备忘提醒仅提醒一次，请及时跟进）</p>
		</Modal>
		<!-- 跟进提醒 -->
		<Modal v-model="showReminderModal" title="跟进提醒" cancel-text="">
			<div class="modal-content">
				<p>通知类型：<span style="color:#63B3E6;cursor: pointer;">优质数量跟进提醒</span></p>
				<p>我的客户：<span style="color:#63B3E6;cursor: pointer;">{{ userInfo.userNotice.myclientThreeNum }}</span>
				</p>
				<p>再分配客户：<span style="color:#63B3E6;cursor: pointer;">{{ userInfo.userNotice.reClientThreeNum }}</span>
				</p>
				<p>备注：<span style="color:#63B3E6;cursor: pointer;">您已有3星客户超3天没跟，请尽快跟进</span></p>
			</div>
			<div slot="footer">
				<Button type="default" @click="showReminderModal = false">关闭</Button>
			</div>
			<!--p>您与<span class='client_name' @click='edit' :data-id='MessageLog.id' :data-name='MessageLog.name'
					style="display: inline-block;margin: 0 4px;color: #85c72f;">{{MessageLog.name}}</span>
				客户{{MessageLog.created_at}}<br>提醒内容：{{MessageLog.remark}}<br>
			</p-->
		</Modal>
		<!-- 客户提醒 -->
		<Modal v-model="messageModal" title="提醒" cancel-text="">
			<div class="modal-content">
				<p>姓名：<span style="color:#63B3E6;cursor: pointer;" @click='edit(MessageLog)'
						:data-id='MessageLog.notice_client_id' :data-name='MessageLog.name'>{{ MessageLog.name }}</span>
				</p>
				<p>通知类型：{{ MessageLog.type }}</p>
				<p>时间：{{ MessageLog.created_at }}</p>
				<p>备注：{{ MessageLog.notice_msg }}</p>
			</div>
			<div slot="footer">
				<Button type="default" @click="messageModal = false">关闭</Button>
			</div>
			<!--p>您与<span class='client_name' @click='edit' :data-id='MessageLog.id' :data-name='MessageLog.name'
					style="display: inline-block;margin: 0 4px;color: #85c72f;">{{MessageLog.name}}</span>
				客户{{MessageLog.created_at}}<br>提醒内容：{{MessageLog.remark}}<br>
			</p-->
		</Modal>
	</Layout>
</template>
<script>
	import SideMenu from './components/side-menu'
	import HeaderBar from './components/header-bar'
	import TagsNav from './components/tags-nav'
	import User from './components/user'
	import ABackTop from './components/a-back-top'
	import Fullscreen from './components/fullscreen'
	import Language from './components/language'
	import ErrorStore from './components/error-store'
	import Message from './components/message/message.vue'
	import TopBar from "../../components/topbar/TopBar";
	import MsgList from "../../components/informCenter/MsgList.vue";
	import {
		removeWatermark,
		setWaterMark
	} from '@/libs/watermark'
	import {
		getNoticeInfoByType,
		signNoticeToRead,
		deleteNotice
	} from '@/api/notice.js'
	import {
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex'
	import {
		getNewTagList,
		routeEqual
	} from '@/libs/util'
	import routers from '@/router/index'
	import minLogo from '@/assets/images/logo-min-new.jpg'
	import maxLogo from '@/assets/images/logo-wan.png'
	import {
		getUserList,
		getMyClientTips,
		getRepeatClientTips,
		getAnnounce,
		getTeamList,
		getDepartmentList,
		getMyAppointment,
		switchAccound,
		setDataSetOpen,
		getMemberByDepartment,
		getMsg,
		setIsFlush
	} from '@/api/user'
	import './main.less'
	export default {
		name: 'Home',
		components: {
			SideMenu,
			HeaderBar,
			Language,
			TagsNav,
			Fullscreen,
			ErrorStore,
			User,
			ABackTop,
			TopBar,
			Message,
			MsgList
		},
		data() {
			return {
				collapsed: false,
				minLogo,
				maxLogo,
				isFullscreen: false,
				iconList: [],
				menuName: '',
				userList: [],
				selectNoticeInfo: [],
				isOpenMsg: false,
				msgCount: 0,
				messageModal: false,
				MessageLog: [],
				msgModal: false,
				msgList: [],
				userId: '',
				currentCenter: '',
				logoSrc: '@/assets/images/logo-wan.png',
				openMenuName: ['my_customer'],
				clientTipsModal: false,
				clientTips: {
					title: '',
					clientId: 0,
					type: 0,
					name: '',
					plat_at: '',
					remark: '',
				},
				homeName: '',
				departmentList: [],
				departmentId: '',
				lastReminderTime: null,
				showReminderModal: false,
				config: {
					time: '22:30:00',
					interval: 1, // 隔几天执行一次
					runNow: false, // 是否立即执行
					intervalTimer: '',
					timeOutTimer: ''
				},
			}
		},
		computed: {
			...mapGetters([
				'userInfo', 'token', 'oldId'
			]),
			tagNavList() {
				return this.$store.state.app.tagNavList
			},
			tagRouter() {
				return this.$store.state.app.tagRouter
			},
			userAvatar() {
				return this.$store.state.user.avatarImgPath
			},
			cacheList() {
				const list = ['ParentView', ...this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item
					.meta.notCache)).map(item => item.name) : []]
				return list
			},
			menuList() {
				return this.$store.getters.menuList
			},
			local() {
				return this.$store.state.app.local
			},
			hasReadErrorPage() {
				return this.$store.state.app.hasReadErrorPage
			},
			unreadCount() {
				return this.$store.state.user.unreadCount
			}
		},
		watch: {
			'$route'(newRoute) {
				const {
					name,
					query,
					params,
					meta
				} = newRoute
				this.addTag({
					route: {
						name,
						query,
						params,
						meta
					},
					type: 'push'
				})
				console.log(getNewTagList(this.tagNavList, newRoute))
				this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
				this.$refs.menus.updateActiveName(newRoute.name)
			}
		},
		mounted() {
			/**
			 * @description 初始化设置面包屑导航和标签导航
			 */
			this.setTagNavList()
			//this.setHomeRoute(routers)
			const {
				name,
				params,
				query,
				meta
			} = this.$route
			this.addTag({
				route: {
					name,
					params,
					query,
					meta
				}
			})
			//this.setBreadCrumb(this.$route)
			// 设置初始语言
			//this.setLocal(this.$i18n.locale)
			// 如果当前打开页面不在标签栏中，跳到homeName页
			if (!this.tagNavList.find(item => item.name === this.$route.name)) {
				this.$router.push({
					name: this.$config.homeName
				})
			}
			// 获取未读消息条数
			//this.getUnreadMessageCount()
		},
		created: function() { //这里是定时器
			this.maxLogo = this.userInfo.ext_info.logo ? this.userInfo.ext_info.logo : this.logoSrc
			setInterval(this.timer, 30000);
			setInterval(this.showReminder, 1800000);
			this.getBussTop10DataByTimer();
			this.loadData();
			// 本地开发时注释掉 goeasy 测试
      // if (process.env.VUE_APP_GO_EASY_SWITCH) {
        this.wsConnect();
      // }
			setWaterMark('', this.userInfo.name + (this.userInfo.id + 1000));
			console.log(this.userInfo)
			if ((this.userInfo.operationCenterStatus == 1 ) && this.userInfo.shop_id == 0) {
				this.currentCenter = "operationCenter"
			} else {
				this.currentCenter = "workCenter"
			}
			console.log(this.currentCenter)
			this.myTips();
		},
		methods: {
			...mapMutations([
				'setTagNavList',
				'addTag',
				'setHomeRoute',
				'closeTag',
				'setoldId',
			]),
			...mapActions([
				'handleLogin',
				'handleToken',
				'getUnreadMessageCount',
				'getUserInfo',
				'handleLogOut'
			]),
			timer: function() { //写成timer()也可
				this.myTips();
				this.getMyAppointment();
				this.getMsg();
				//this.getRepeatClientTips();
			},
			showReminder: function() {
				const now = new Date();
				const hour = now.getHours();
				console.log(hour)
				this.getUserInfo();
				console.log(this.userInfo)
				if (hour === 9 || hour === 15 || hour === 19) {
					if (!this.lastReminderTime || this.lastReminderTime.getHours() !== hour) {
						this.lastReminderTime = now;
						//这些时间点获取未跟进的3星数量情况
						if (this.userInfo.userNotice.myclientThreeNum != 0 && this.userInfo.userNotice
							.reClientThreeNum != 0) {
							this.showReminderModal = true;
						}
					}
				}
			},
			wsConnect() {
				const that = this
				const wsUrl = process.env.VUE_APP_WS_URL || 'ws://localhost:8001'
				that.$store.commit('setWsConnected', false)
				let socket = null
				let reconnectTimer = null
				let heartbeatTimer = null
				let reconnectAttempts = 0
				const maxReconnectAttempts = 10
				const reconnectInterval = 5000

				function send(data) {
					if (socket && socket.readyState === WebSocket.OPEN) {
						socket.send(JSON.stringify(data))
					}
				}

				function startHeartbeat() {
					stopHeartbeat()
					heartbeatTimer = setInterval(() => {
						send({ event: 'ping' })
					}, 30000)
				}

				function stopHeartbeat() {
					if (heartbeatTimer) {
						clearInterval(heartbeatTimer)
						heartbeatTimer = null
					}
				}

				function scheduleReconnect() {
					if (reconnectAttempts >= maxReconnectAttempts) {
						console.error('[WS] 达到最大重连次数，不再重连')
						return
					}
					if (reconnectTimer) clearTimeout(reconnectTimer)
					reconnectAttempts++
					const delay = reconnectInterval * Math.pow(1.5, reconnectAttempts - 1)
					console.log(`[WS] ${Math.round(delay / 1000)}s 后重连 (${reconnectAttempts}/${maxReconnectAttempts})`)
					reconnectTimer = setTimeout(connect, delay)
				}

				function connect() {
					socket = new WebSocket(wsUrl)

					socket.onopen = function() {
						console.log('[WS] 连接已打开，发送认证')
						reconnectAttempts = 0
						that.$store.commit('setWsConnected', false) // 等待认证成功后再设为true
						send({
							event: 'auth',
							token: that.token,
							uid: that.userInfo.id,
							client_type: 'web'
						})
					}

					socket.onmessage = function(res) {
						try {
							const msg = JSON.parse(res.data)
							const event = msg.event || msg.type
							console.log('[WS] 收到消息:', JSON.stringify(msg))

							// 认证失败
							if (msg.code === 401) {
								console.error('[WS] 认证失败:', msg.msg)
								socket.close()
								return
							}

							// 认证成功
							if (event === 'auth_success') {
								console.log('[WS] 认证成功, uid:', msg.uid)
								that.$store.commit('setWsConnected', true)
								startHeartbeat()
								return
							}

							// 心跳响应
							if (event === 'pong') return

							// 连接已建立
							if (event === 'pusher:connection_established' || res.data === 'ok') return

							// 拨号请求事件
							if (event === 'dial-request') {
								const data = msg.data || msg
								console.log('[WS] 收到拨号请求, 完整消息:', JSON.stringify(msg), ', data:', JSON.stringify(data))
								// 适配原有 modal 需要的字段结构
								that.MessageLog = {
									notice_client_id: data.client_id || data.clientId,
									phone: data.phone,
									name: data.name || '客户',
									type: '拨号请求',
									created_at: new Date().toLocaleString(),
									notice_msg: data.phone ? '收到拨号请求：' + data.phone : '收到拨号请求',
								}
								that.messageModal = true
								that.getMsg() // 刷新未读消息数
								return
							}

							// App 上线通知
							if (event === 'app-online') {
								console.log('[WS] 收到 app-online 通知')
								that.$store.commit('setAppOnline', true)
								return
							}

							// App 离线通知
							if (event === 'app-offline') {
								console.log('[WS] 收到 app-offline 通知')
								that.$store.commit('setAppOnline', false)
								return
							}

							// 连接被踢（同一账号的另一个连接接管了）
							if (event === 'connection-replaced') {
								console.log('[WS] 连接被踢出: 另一个连接接管了')
								socket.close()
								return
							}
						} catch (e) {
							// 忽略解析失败的消息
						}
					}

					socket.onclose = function() {
						console.log('[WS] 连接断开')
						that.$store.commit('setWsConnected', false)
						stopHeartbeat()
						scheduleReconnect()
					}

					socket.onerror = function(err) {
						console.error('[WS] 连接错误', err)
						that.$store.commit('setWsConnected', false)
						stopHeartbeat()
						scheduleReconnect()
					}
				}

				connect()
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token,
					only_customer: 1,
					getSelf: 1,
				};
				let res = await getTeamList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			async departmentMemberSelect() {
				let that = this;
				let data = {
					token: this.token
				};
				data.id = that.departmentId;
				let res = await getMemberByDepartment(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;

				}
			},
			async myTips() {
				let that = this;
				var data = {
					token: this.token
				};
				console.log(this.token)
				let res = await getMyClientTips(that, data);
				if (res.code == 1) {
					that.clientTipsModal = true;
					that.clientTips = res.data;
				}
			},
			async getMsg() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getMsg(that, data);
				if (res.code == 1) {
					that.msgList = res.data.msgList;
					var newMsgCount = that.msgList.length;
					if (newMsgCount > that.msgCount) {
						that.isOpenMsg = true;
					}
					that.msgCount = newMsgCount;
					if (res.data.is_flush == "1") {
						this.getUserInfo()
					}

				}

			},
			async getRepeatClientTips() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getRepeatClientTips(that, data);
				if (res.code == 1) {
					that.clientTipsModal = true;
					that.clientTips = res.data;
				}
			},
			async getMyAppointment() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getMyAppointment(that, data);
				if (res.code == 1) {
					that.clientTipsModal = true;
					that.clientTips = res.data;
				}
			},
			editTipsModal(id, name) {
				let that = this;
				this.editDiv = true;
				that.clientTipsModal = false;
				console.log(id)
				this.$nextTick(function() {
					this.$router.push({
						name: 'newEditClue',
						params: {
							id: id,
							name: name,
							data: that.datas
						},
					})

				})

			},
			edit(item) {
				let that = this;
				that.signToRead(item);
				if (item.notice_client_id == null || item.notice_client_id == undefined || item.notice_client_id == "") {
					this.$Message.error('系统不存在该客户');
					return
				}
				that.messageModal = false;
				this.$nextTick(function() {
					this.$router.push({
						name: 'newEditClue',
						params: {
							id: item.notice_client_id,
							name: item.client_name,
							data: that.datas
						},
					})
				})
			},
			turnToPage(route) {
				console.log(route)
				let {
					name,
					params,
					query
				} = {}
				if (typeof route === 'string') {

					name = route
				} else {
					name = route.name
					params = route.params
					query = route.query
				}
				this.$router.push({
					name,
					params,
					query
				})
			},
			menuHandleClick(e) {},
			async switchAccound() {

				let that = this;
				if (that.userId == "" || that.userId == null) {
					this.$Message.error('请选择切换客户经理');
					return;
				}
				let oldId = window.localStorage['oldId'] ? window.localStorage['oldId'] : that.userInfo.id
				var data = {
					token: this.token,
					id: this.userId,
					oldId: oldId,
				};
				let switchRes = await switchAccound(that, data);
				that.handleToken(switchRes.data.token);
				that.setoldId(Number(switchRes.data.oldId))

				if (switchRes.code == 1) {
					let res1 = this.tagNavList.filter(item => item.name === this.$config.homeName)
					this.handleCloseTag(res1, 'all');
					this.loadData();
					this.getUserInfo().then(res => {
						if (res.code == 1) {
							this.$router.push({
								name: res.data.router
							})
							that.$Message.success('切换成功');
						}
					})
				}

			},
			signToRead(selectData) {
				let that = this;
				this.selectNoticeInfo = [];
				this.selectNoticeInfo.push(selectData)
				let data = {
					token: this.token,
					noticeInfo: this.selectNoticeInfo
				}
				if (that.selectNoticeInfo.length) {
					signNoticeToRead(data).then(function(res) {
						if (res.data.code == 1) {
							that.myTips();
							that.$Message.success('标记成功');
							that.getMsg();
						} else {
							that.$Message.warning('标记失败');
						}
					});
				} else {
					that.$Message.warning('请先选择');
				}
			},
			signAllRead(selectData) {
				let that = this;
				this.selectNoticeInfo = selectData;
				let data = {
					token: this.token,
					noticeInfo: this.selectNoticeInfo
				}
				that.$Modal.confirm({
					title: '确认全部标记已读吗？',
					onOk: async () => {
						if (that.selectNoticeInfo.length) {
							signNoticeToRead(data).then(function(res) {
								if (res.data.code == 1) {
									that.myTips();
									that.$Message.success('标记成功');
									that.getMsg();
								} else {
									that.$Message.warning('标记失败');
								}
							});
						} else {
							that.$Message.warning('请先选择');
						}
					}
				})
			},
			openAllMsg() {
				this.msgModal = true;
			},
			async backAccound() {
				let that = this;
				if (window.localStorage['oldId'] == "" || window.localStorage['oldId'] == null) {
					this.$Message.error('还未切换');
					return;
				}

				var data = {
					token: this.token,
					id: window.localStorage['oldId'],
				};
				let switchRes = await switchAccound(that, data);
				that.handleToken(switchRes.data.token);
				if (switchRes.code == 1) {
					let res1 = this.tagNavList.filter(item => item.name === this.$config.homeName)
					this.handleCloseTag(res1, 'all')
					this.loadData();
					this.getUserInfo().then(res => {
						if (res.code == 1) {
							this.$router.push({
								name: res.data.router
							})
							that.$Message.success('还原成功');
						}
					})
				}
			},
			dataOpen(status) {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						index: status
					}
					let res = await setDataSetOpen(that, data);
					if (res.code == 1) {
						that.getUserInfo();
						that.$Message.success(res.msg);
					}
				}, 500)
			},
			goToMycenter() {
				this.$router.push({
					name: 'myCenter',
					query: {
						uid: this.userInfo.id
					}
				})
			},
			handleCollapsedChange(state) {
				this.collapsed = state
			},
			handleCloseTag(res, type, route) {
				if (type !== 'others') {
					if (type === 'all') {
						//根据不同的权限保留不同的page
						if (this.userInfo.role_type == 1) {
							this.homeName = 'client_statistics';
						} else if (this.userInfo.role_type == 3) {
							this.homeName = 'cost_report';
						} else if (this.userInfo.role_type == 9 && this.userInfo.department == 1) {
							//超级管理员的财务
							this.homeName = 'cost_report';
						} else {
							this.homeName = 'myclient';
						}
						console.log(this.userInfo)
						this.turnToPage(this.homeName)
					} else {
						if (routeEqual(this.$route, route)) {
							this.closeTag(route)
						}
					}
				}
				this.setTagNavList(res)
			},
			handleClick(item) {
				this.turnToPage(item)
			},
			searchNameMenuItem(menuName, openMenuName) {
				let that = this;
				if (menuName != '' && openMenuName != '') {
					this.needInitSearch = false;
					this.menuName = menuName;
					this.openMenuName = openMenuName;
					this.$nextTick(() => {
						that.$refs.menus.updateOpened();
						that.$refs.menus.updateActiveName();
					})
				} else {
					this.needInitSearch = true;
				}
			},
			openMenuClass(e) {
				this.currentCenter = e
			},
			menuItem(e) {
				this.menuName = e;
				this.needInitSearch = true;
			},
			redistributionNotFollow() {
				this.$router.push('/client')
			},
			initIcon() {
				let that = this
				this.userInfo.menuList.client.children.forEach(function(row, index) {
					that.iconList[index] = require('../../assets/icons/client/' + row.key + '.png');
				})
			},
			openMenuItem(e) {
				if (e.length > 0) {
					this.openMenuName = e
				}
				if (e[0] == 'my_customer') {
					this.menuName = 'myclient'
				} else if (e[0] == 'onsite_customer') {
					this.menuName = 'did_not_sign_up'
				} else if (e[0] == 'loan_customer') {
					this.menuName = 'underway'
				} else if (e[0] == 'history_customer') {
					this.menuName = 'history_customer_detail'
				} else if (e[0] == 'departmental_account_management') {
					this.menuName = 'team_new_client'
				} else if (e[0] == 'department_contract_management') {
					this.menuName = 'team_did_not_sign_up'
				} else if (e[0] == 'department_loan_management') {
					this.menuName = 'sign_management'
				} else if (e[0] == 'public_pool') {
					this.menuName = 'media_set'
				}
			},
			closeMsg(status) {
				this.isOpenMsg = status;
			},
			async adminSet() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						is_flush: 1
					}
					let res = await setIsFlush(that, data);
					if (res.code == 1) {
						that.getUserInfo();
						that.$Message.success(res.msg);
					}
				}, 500)
			},
			getBussTop10DataByTimer() {
				if (this.config.runNow) {
					// 如果配置了立刻运行则立刻运行任务函数
					this.initTopTenBusiness()
				}
				// 获取下次要执行的时间，如果执行时间已经过了今天，就让把执行时间设到明天的按时执行的时间
				var nowTime = new Date().getTime()
				var timePoint = this.config.time.split(':').map((i) => parseInt(i))

				var recent = new Date().setHours(...timePoint) // 获取执行时间的时间戳

				if (recent <= nowTime) {
					recent += 24 * 60 * 60 * 1000
				}
				// 未来程序执行的时间减去现在的时间，就是程序要多少秒之后执行
				var doRunTime = recent - nowTime
				this.config.timeOutTimer = setTimeout(this.setTimer, doRunTime)
			},
			setTimer() {
				console.log('进入定时器')
				//配置后的第一天12点执行
				this.initTopTenBusiness()
				// 每隔多少天再执行一次
				var intTime = this.config.interval * 24 * 60 * 60 * 1000
				this.config.intervalTimer = setInterval(this.initTopTenBusiness, intTime)
			},
			initTopTenBusiness() {
				this.handleLogOut();
				this.$router.push({
					name: 'login'
				})
			}
		},
	}
</script>
<style>
	.clear {

		clear: both;

	}

	.modal-content {
		padding: 20px;
		font-size: 16px;
		line-height: 1.5;
	}

	.basinfo {
		-webkit-box-shadow: 3px 0 4px #e5e5e5;
		-moz-box-shadow: 3px 0 4px #e5e5e5;
		box-shadow: 3px 0 4px #e5e5e5;
		margin: 5px;
	}

	.touxiang {
		width: 100%;
	}

	.basinfo .information {
		margin-left: 15%;
		margin-right: 2px;
	}

	.information {
		font-size: 12px;
		margin: -5px 0 0 24%;
	}

	p {
		margin: 0px;
	}

	.info {
		line-height: 28px;
		clear: both;
	}

	/deep/ .ivu-menu-light {
		background-color: #000000;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}

	.badge {
		background-color: #f0f0f0;
		position: absolute;
		width: 50px;
		height: auto;
		top: 30%;
		right: 10%;
	}

	.message_tool {
		width: 70px;
		height: 70px;
		position: fixed;
		bottom: 50px;
		right: 50px;
		text-align: center;
		z-index: 1004;
		border-radius: 50%;
		-webkit-box-shadow: 0 0 5px 2px #aaa;
		box-shadow: 0 0 5px 2px #aaa;
	}


	.message_tool .icon {
		position: relative;
		width: 70px;
		height: 70px;
		top: 0;
		opacity: .8;
		filter: Alpha(opacity=80);
	}

	.message_tool .noread_num {
		position: absolute;
		background: #31495d;
		line-height: 18px;
		font-size: 12px;
		color: #fff;
		font-weight: 700;
		min-width: 18px;
		border-radius: 9px;
		display: inline-block;
		left: 39px;
		top: 10px;
		z-index: 1;
	}

	.message_div_show {
		display: block;
	}

	.message_div {
		z-index: 1005;
		width: 350px;
		position: fixed;
		background-color: #eee;
		color: #333;
		bottom: 10px;
		padding: 10px;
		right: 10px;
		overflow-y: auto;
		border-radius: 5px;
		border: 1px solid #aaa;
		-webkit-box-shadow: #a9a9a9 -2px -2px 5px 0;
		box-shadow: -5px -5px 10px 0 #a9a9a9;
		-webkit-transition: all 1s;
		transition: all 1s;

	}

	.ivu-menu {
		display: block;
		margin: 0;
		padding: 0;
		outline: 0;
		list-style: none;
		color: #515a6e;
		font-size: 14px;
		position: relative;
		z-index: 900;
	}

	.message_div .title {
		line-height: 20px;
		font-size: 16px;
		padding-bottom: 10px;
		text-align: center;
		font-weight: 700;
		border-bottom: 2px solid #eee;
	}

	.message_div .content {
		height: 450px;
		background: #fff;
		overflow-y: auto;
	}

	.message_div .content .one_div_l {
		border: 1px solid #b4f8d2;
	}

	.message_div .content .one_div {
		line-height: 25px;
		margin: 10px 10px 0;
		background: #fff;
		border-radius: 5px;
		font-size: 14px;
		color: #000;
		border: 1px solid #dcdfe6;
		overflow: hidden;
		padding-bottom: 7px;
		-webkit-transition: all 1s;
		transition: all 1s;
		min-height: 80px;
	}

	.message_div .content .one_div_l .msg_title {
		background: #b4f8d2;
	}

	.message_div .content .one_div .msg_title {
		position: relative;
		background: #dcdfe6;
		text-align: left;
		padding-left: 10px;
		color: #333;
		font-size: 13px;
		font-weight: 700;
		line-height: 30px;
	}

	.message_div .content .one_div .msg_title .status {
		position: absolute;
		font-size: 12px;
		font-weight: 400;
		right: 5px;
		color: #555;
		cursor: pointer;
	}

	.message_div .content .one_div .msg_content {
		position: relative;
		line-height: 16px;
		font-size: 13px;
		padding: 10px 10px 5px;
	}

	.message_div .content .one_div .opt {
		position: relative;
	}

	.message_div .content .one_div .opt .time {
		position: relative;
		float: left;
		margin-left: 10px;
		font-size: 13px;
		color: #999;
		line-height: 20px;
	}

	.message_div .content .one_div .opt .go {
		position: relative;
		float: right;
		margin-right: 10px;
		font-size: 13px;
		color: #c22834;
		line-height: 20px;
		font-weight: 700;
	}

	.message_div .content .one_div {
		line-height: 25px;
		margin: 10px 10px 0;
		background: #fff;
		border-radius: 5px;
		font-size: 14px;
		color: #000;
		border: 1px solid #dcdfe6;
		overflow: hidden;
		padding-bottom: 7px;
		-webkit-transition: all 1s;
		transition: all 1s;
		min-height: 80px;
	}


	.message_div .shouce_guanbi {
		position: absolute;
		top: 6px;
		right: 10px;
		width: 25px;
		height: 25px;
		font-size: 25px;
		color: #c22834;
	}

	.message_div .ge_to_log {
		position: absolute;
		top: 15px;
		left: 10px;
		font-size: 10px;
		color: #c22834;
	}

	.warning-msg {
		display: block;
		bottom: 20px;
		right: 0px;
		position: fixed;
	}

	.warning-msg-close {
		display: none;
	}

	.notification {
		font-family: Digital, 'Microsoft YaHei', STFangsong;
		display: flex;
		margin: 0 auto;
		width: 300px;
		min-height: 80px;
	}

	.notification .info {
		flex: 1;
		padding: 10px 10px 0 10px;
		background: #6c7e98;
		border-radius: 3px 0 0 3px;
		border-bottom: 3px solid #c0cdd1;
	}

	.notification .info span {
		margin: 0;
		padding: 0;
		font-size: 16px;
		color: #fff;
	}

	.notification .info p {
		margin: 0;
		padding: 5px 0;
		font-size: 12px;
		color: #c5bebe;
	}

	.notification .info .button {
		display: inline-block;
		margin: 3px 3px 5px 0;
		padding: 3px 7px;
		border-radius: 2px;
		border-bottom: 1px solid;
		font-size: 12px;
		font-weight: bold;
		text-decoration: none;
		color: #ecf0f1;
	}

	.notification .info .button.gray {
		background: #95a5a6;
		border-bottom-color: #798d8f;
	}

	.notification .info .button {
		background: #435d8a;
		border-bottom-color: #435d8a;
	}
</style>